<template>
  <div :class="topPage ? 'content-container' : ''">
    <el-breadcrumb separator="/" v-if="topPage">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>发货记录</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
          @submit.native.prevent
        >
          <el-form-item
            label="关键字"
            prop="query"
            v-if="isMobile() && !filterShow"
          >
            <el-input
              size="small"
              v-model="filter.query"
              autocomplete="off"
              placeholder="发货编号、设备号"
              @keyup.enter.native="reqeustCustomerDevices"
            ></el-input>
          </el-form-item>
          <div class="filter-block" v-show="filterShow || !isMobile()">
            <el-form-item
              label="关键字"
              prop="query"
              v-if="filterShow || !isMobile()"
            >
              <el-input
                size="small"
                v-model="filter.query"
                autocomplete="off"
                placeholder="发货编号、设备号"
                @keyup.enter.native="reqeustCustomerDevices"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="最终客户"
              prop="ship_customer_id"
              v-if="!customerID"
            >
              <customer-select
                :val="filter.ship_customer_id"
                @change="filter.ship_customer_id = $event"
              ></customer-select>
            </el-form-item>
            <el-form-item
              label="中间商"
              prop="sold_customer_id"
              v-if="auth.isPlatformUser() && !customerID"
            >
              <customer-select
                :val="filter.sold_customer_id"
                @change="filter.sold_customer_id = $event"
              ></customer-select>
            </el-form-item>
            <el-form-item label="发货日期" prop="date">
              <el-date-picker
                style="width: 360px"
                v-model="filter.date"
                type="daterange"
                size="small"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </div>
        </el-form>
        <div class="mt-10 flex-row-between">
          <div>
            <el-button
              type="primary"
              size="small"
              @click="
                filter.page = 1
                reqeustCustomerDevices()
              "
              >筛选</el-button
            >
            <el-button size="small" @click="reset()">重置</el-button>
          </div>
          <div
            class="flex-row-base"
            v-if="isMobile()"
            @click="
              filterShow = !filterShow
              scrollToTop()
            "
          >
            <i
              class="text-gray"
              :class="filterShow ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            ></i>
            <span class="text-info-12">
              {{ filterShow ? '隐藏高级筛选' : '展开高级筛选' }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <div class="header" v-if="!customerID">
        <div style="float: right">
          <file-button
            class="mobile-hide"
            obj="customer_device_delivery"
            style="float: right"
            :filter="filter"
            :exportButton="false"
            :downTemplate="false"
            @importCallback="reqeustCustomerDevices"
            v-permission="Auth.customerDeviceDeliveryIE"
          ></file-button>
        </div>
      </div>

      <el-table
        v-if="!isMobile()"
        v-loading="loading"
        ref="customerDeviceTable"
        :data="devices"
        stripe
        style="width: 100%"
        size="mini"
      >
        <el-table-column prop="delivery_no" label="发货编号"></el-table-column>
        <el-table-column prop="delivery_date" label="发货日期">
          <template slot-scope="scope">
            {{ formatTime(scope.row.delivery_date) }}
          </template>
        </el-table-column>
        <el-table-column label="客户信息" min-width="200">
          <template slot-scope="scope">
            <template>
              最终客户：
              <customer-link
                class="mr-5"
                :customer="scope.row.customer"
              ></customer-link>
              <template v-if="auth.isPlatformUser()">
                <div v-if="scope.row.sold_customer_id">
                  中间商：
                  <customer-link
                    class="font-12"
                    :customer="scope.row.dealer"
                  ></customer-link>
                </div>
              </template>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="material" label="设备号"></el-table-column>
        <el-table-column prop="description" label="描述"></el-table-column>
        <el-table-column
          prop="quantity"
          label="数量"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="unit"
          label="单位"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="division"
          label="部门"
          align="center"
        ></el-table-column>
      </el-table>
      <ul v-else class="list-style">
        <li v-for="item in devices" :key="item.id" style="align-items: start">
          <div class="font-12">
            <span>发货编号：</span>{{ item.delivery_no }}
          </div>
          <div class="font-12">
            <span>发货日期：</span>{{ formatTime(item.delivery_date) }}
          </div>
          <div class="font-12"><span>设备号：</span>{{ item.material }}</div>
          <div class="font-12"><span>数量：</span>{{ item.quantity }}</div>
          <div class="font-12"><span>单位：</span>{{ item.unit }}</div>
          <div class="font-12"><span>部门：</span>{{ item.division }}</div>
          <div class="font-12"><span>描述：</span>{{ item.description }}</div>
          <div
            class="font-12"
            v-if="auth.isPlatformUser() && item.ship_customer_id"
          >
            最终客户：
            <customer-link :customer="item.customer"></customer-link>
          </div>
          <div
            class="font-12"
            v-if="auth.isPlatformUser() && item.sold_customer_id"
          >
            中间商：
            <customer-link :customer="item.dealer"></customer-link>
          </div>
        </li>
      </ul>
      <div v-if="devices.length == 0 && isMobile()" class="text-info-12">
        暂无数据。
      </div>
      <el-pagination
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
        class="mt-20"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { customerDeviceDeliveryList } from '../../service/getData'
import { isMobile, formatTime, scrollToTop } from '@/util/index'
import CustomerSelect from '@/components/select/customer_select'
import auth from '@/util/auth'

export default {
  components: {
    CustomerSelect,
  },
  props: {
    customerID: {
      type: Number,
      default: 0,
    },
    topPage: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      filter: {
        query: '',
        date: [],
        customer_id: this.customerID || 0,
        sold_customer_id: 0,
        ship_customer_id: 0,
        size: 20,
        page: 1,
      },
      isMobile,
      formatTime,
      scrollToTop,
      total: 0,
      auth,
      devices: [],
      filterShow: false,
      loading: false,
    }
  },
  watch: {
    'filter.page': function () {
      this.reqeustCustomerDevices()
    },
  },
  created() {
    this.filter = {
      page: parseInt(this.$route.query.page || 1),
      size: parseInt(this.$route.query.size || 20),
      customer_id: parseInt(this.$route.query.customer_id || 0),
      sold_customer_id: parseInt(this.$route.query.sold_customer_id || 0),
      ship_customer_id: parseInt(this.$route.query.ship_customer_id || 0),
      query: this.$route.query.query || '',
      date: this.$route.query.date || [],
    }

    if (this.customerID) {
      this.filter.customer_id = this.customerID
    }

    this.reqeustCustomerDevices()
  },
  methods: {
    getSearchData() {
      let data = {
        page: this.filter.page - 1,
        size: this.filter.size,
        customer_id: this.customerID || 0,
        sold_customer_id: this.filter.sold_customer_id || 0,
        ship_customer_id: this.filter.ship_customer_id || 0,
        query: this.filter.query,
      }

      if (this.filter.date && this.filter.date.length == 2) {
        data.start_time = this.filter.date[0] || ''
        data.end_time = this.filter.date[1] || ''
      }

      return data
    },
    async reqeustCustomerDevices() {
      this.$router.replace({
        query: this.filter,
      })

      this.loading = true
      let res = await customerDeviceDeliveryList(this.getSearchData())
      if (res.code == 0) {
        this.devices = res.data.list
        this.total = res.data.total
      }
      this.loading = false
    },

    reset() {
      this.filter.query = ''
      this.filter.page = 1
      this.filter.customer_id = this.customerID || 0
      this.filter.sold_customer_id = 0
      this.filter.ship_customer_id = 0
      this.filter.date = []
      this.reqeustCustomerDevices()
    },
    importCallback(res) {
      if (res.code == 0) {
        this.reset()
      }
    },
  },
}
</script>